<template>
	<div :class="portalClass">
		<alert-container></alert-container>
		<header role="banner">
			<nav>
				<ul>
					<li>
						<router-link :to="{name: 'dashboard'}" class="brand">
							<span v-if="!partnerLogo" v-html="partnerName"/>
							<img v-else :alt="partnerName" :src="partnerLogo" class="brand__img"/>
						</router-link>
					</li>
				</ul>
				<ul class="flex gap-1 items-center py-1">
					<li v-if="nextTask || remainingTasks">
						<button
							class="button button--primary--small" @click.prevent="showNextTaskModal()">What's Next?
						</button>
					</li>
					<TheAccountContextual/>
				</ul>
			</nav>
		</header>
		<main role="main">
			<div class="content-safe-space">
				<slot/>
			</div>
		</main>
		<Modal/>
	</div>
</template>
<script>
import autoLogout from "@/mixins/autoLogout";
import {mapMutations} from "vuex";
import VContextualContent from "../../../common/components/v-contextual/v-contextual-content";
import watchesRouteChanged from "../../../mixins/watchesRouteChanged";
import watchesWindowResizeEvent from "../../../mixins/watchesWindowResizeEvent";
import TheAccountContextual from "../components/TheAccountContextual.vue";
import essentialTasks from "../mixins/essentialTasks";
import invoices from "../mixins/invoices";

export default {
	components: {
		TheAccountContextual,
		VContextualContent,
	},

	mixins: [
		autoLogout,
		essentialTasks,
		invoices,
		watchesWindowResizeEvent,
		watchesRouteChanged,
	],

	data() {
		return {
			expanded: false,
			showNav: false,
			timeout: null,
			routerViewKey: 0,
		};
	},

	computed: {
		nextTask() {
			return this.$store.getters.nextTask();
		},
		remainingTasks() {
			return this.$store.getters.remainingTasks();
		},
		portalClass() {
			return {
				"expanded": this.expanded,
				"nav-on": this.showNav,
			};
		},
	},

	methods: {
		...mapMutations([
			"setIdCheckSession",
		]),
		routeChanged() {
			this.showNav = false;
		},
		windowResized({innerWidth}) {
			let threshold = innerWidth >= 1024;
			this.expanded = threshold;
			this.showNav = !threshold ? this.showNav : false;
		},
		initEcho() {
			window.Echo.private(`idChecks.${this.$authed().idCheck.id}`)
				.listen(".idChecks.idCheckUpdated", () => {
					this.$store.dispatch("authStore/authed").then(() => {
						if (this.$authed().idCheck.isComplete) {
							this.setIdCheckSession();
						}
					});
				})
				.listenForWhisper("sessionStarted", (data) => {
					this.setIdCheckSession(data);
					this.openCompleteIdCheckModal();
				})
				.listenForWhisper("sessionClosed", (data) => {
					this.setIdCheckSession();
				});
		},
		whisperPortalLoaded() {
			window.Echo.private(`idChecks.${this.$authed().idCheck.id}`).whisper("portalLoaded");
		},
	},

	mounted() {
		this.initEcho();
		this.whisperPortalLoaded();
	},
};
</script>
